// TO DO:
// - error handling - add modal to let user know to select address first?

document.addEventListener('DOMContentLoaded', function () {

    const registrySearchContainer = document.querySelector('.registry-search__container');
    const registrySearchInput = document.getElementById('registry-search-input');
    const addressDropdown = document.querySelector('.address-dropdown');
    const registrySearchButton = document.querySelector('#registrySearchBtn');

    function buildAddress(suggestion) {
        let whiteSpace = "";
        let suggestionSecondary = suggestion.secondary;
        if (suggestion.secondary) {
            if (suggestion.entries > 1) {
                suggestionSecondary = suggestion.secondary + "... ";
            }
            whiteSpace = " ";
        }
        return suggestion.street_line + whiteSpace + suggestionSecondary + " " + suggestion.city + ", " + suggestion.state + " " + suggestion.zipcode;
    }

    function buildSearchUrl(addressObj) {
        // let registryUrl = new URL("https://registry.pearlscore.com/map/");   // Product URL 
        let registryUrl = new URL("https://develop.registry.pearlscore.com/map/");  // Staging URL for testing
        let address;
        if (addressObj.secondary) {
            // console.log(addressObj)
            address = encodeURIComponent(`${addressObj.street_line} ${addressObj.secondary} ${addressObj.city} ${addressObj.state} ${addressObj.zipcode}`);
        } else {
            address = encodeURIComponent(`${addressObj.street_line} ${addressObj.city} ${addressObj.state} ${addressObj.zipcode}`);
        }
        // console.log(registryUrl.pathname += address)
        // return registryUrl.pathname += address;
        return registryUrl.origin + (registryUrl.pathname += address)
    }

    function handleAddressClick(suggestion, addressObj) {
        // console.log(suggestion.firstElementChild);

        if (suggestion.firstElementChild.tagName !== "I") {
            const optionsAddress = `${addressObj.street_line} ${addressObj.secondary} (${addressObj.entries}) ${addressObj.city} ${addressObj.state} ${addressObj.zipcode}`;
            fetchAddressSuggestions(registrySearchInput.value.trim(), optionsAddress)
            // console.log(optionsAddress)
        } else {
            document.querySelector('.registry-search .instructions').style.opacity = '0';

            // - Change the search input value to the selected address + update search button href
            registrySearchInput.value = suggestion.textContent;
            addressDropdown.style.display = 'none';
            // - Place focus on the submit button
            registrySearchButton.focus();

            const registryUrl = buildSearchUrl(addressObj);
            registrySearchButton.setAttribute("href", registryUrl);
            registrySearchButton.setAttribute("target", "_blank");
            registrySearchButton.setAttribute("aria-disabled", false);
            registrySearchButton.setAttribute("tabindex", "0");
            registrySearchButton.classList.remove("disabled");
        }
        
    }

    function initAddressButton(addressButton, addressObj) {
        addressButton.addEventListener('click', (e) => {
            handleAddressClick(e.target, addressObj);
        })
    }

    function buildSuggestionsDropdown(suggestion) {
        let addressButton;
        if (!suggestion.secondary || suggestion.secondary && suggestion.entries <= 1) {
            addressButton = document.createElement('a');
        } else {
            addressButton = document.createElement('button');
        }
        
        addressButton.classList.add('address');
        const addressText = buildAddress(suggestion);
        addressButton.appendChild(document.createTextNode(addressText));
        addressDropdown.appendChild(addressButton);

        if (!suggestion.secondary || suggestion.secondary && suggestion.entries <= 1) {
            addressButton.setAttribute('href', '#');
            const registryUrl = buildSearchUrl(suggestion);
            addressButton.setAttribute("href", registryUrl);
            addressButton.setAttribute("target", "_blank");

            const iconEl = document.createElement('i');
            iconEl.classList.add('i-arrow-right');
            addressButton.appendChild(iconEl);
        }
        if (suggestion.entries > 1) {
            const expandTextEl = document.createElement('span');
            const expandText = document.createTextNode(`+${suggestion.entries} addresses`);
            expandTextEl.appendChild(expandText);
            addressButton.appendChild(expandTextEl);
        }

        initAddressButton(addressButton, suggestion);
    }

    async function fetchAddressSuggestions(input, secondary) {
        const url = new URL('https://us-autocomplete-pro.api.smarty.com/lookup');
        url.searchParams.append('key', '17929281288993164');
        url.searchParams.append('search', input);
        
        if (secondary) {
            url.searchParams.append('selected', secondary)
            // console.log(url)
        }
    
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Smarty API error: ${response.status} ${response.statusText}`);
            }
    
            const data = await response.json();
            // console.log(data.suggestions); // Array of address suggestions

            resetSubmitButton(); // Reset submit button everytime a new search is being made or previous search is altered
            addressDropdown.innerHTML = ''; // Refresh the list by removing old data before re-rendering new data
            
            if (input !== "" && data.suggestions.length > 0) {
                addressDropdown.style.display = "flex";
                addressDropdown.setAttribute("aria-expanded", "true");
                data.suggestions.forEach((suggestion) => {
                    buildSuggestionsDropdown(suggestion);
                });

                document.querySelector('.registry-search .instructions').style.opacity = '1';

                if (secondary) {
                    addressDropdown.children[0].focus(); 
                }
            } 
            return data.suggestions;
        } catch (error) {
            console.error('Failed to fetch address suggestions:', error);
            return [];
        }

    }

    function resetSubmitButton() {
        registrySearchButton.setAttribute("href", "javascript:void(0)");
        registrySearchButton.setAttribute("aria-disabled", "true");
        registrySearchButton.setAttribute("tabindex", "-1");
        registrySearchButton.removeAttribute("target");
        registrySearchButton.classList.add("disabled");
    }


    // ================================================================================================

    function initEventListeners() {
        let index = 0;

        // Keyboard event listeners / navigation
        document.addEventListener('keydown', function (event) {
            // Close dropdown when 'Esc' is pressed
            if (event.key === 'Escape') {
                index = 0;
                if (addressDropdown.style.display = 'flex') {
                    addressDropdown.style.display = 'none';
                    addressDropdown.setAttribute("aria-expanded", "false");
                    registrySearchInput.focus();
                }
            // Trigger submit on pressing 'Enter' when address is filled and submit button is enabled
            } else if (event.key === 'Enter') {
                index = 0;
                if (document.activeElement.id === 'registry-search-input' && registrySearchButton.getAttribute('aria-disabled') === 'false') {
                    registrySearchButton.click();
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                if (document.activeElement.id === 'registry-search-input' && addressDropdown.style.display === 'flex') {
                    document.querySelector('.address-dropdown').children[0].focus();
                } else if (document.activeElement.className === "address") {
                    if (index < (document.querySelectorAll('.address-dropdown .address').length - 1)) {
                        index++;
                    }
                    document.querySelector('.address-dropdown').children[index].focus();
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                if (document.activeElement.className === "address") {
                    if (index > 0) {
                        index--;
                    }
                    document.querySelector('.address-dropdown').children[index].focus();
                }
            }

            if (document.activeElement.id === 'registry-search-input' || document.activeElement.className === 'address') {
                if (event.key === 'Tab') {
                    // Tab (as well as Shift+Tab) should skip the suggestions dropdown and go to the next tabbable element
                    addressDropdown.style.display = 'none';
                    addressDropdown.setAttribute('aria-expanded', 'false');
                    index = 0;
                }
            }
        });
        
        // Close dropdown when clicking outside of it
        document.addEventListener('click', function (event) {
            // Check if the click was outside the dropdown
            if (!registrySearchContainer.contains(event.target)) {
                addressDropdown.style.display = 'none';
                addressDropdown.setAttribute('aria-expanded', false);
            } else {
                index = 0;
            }
        });
    }

    const doSearch = () => {
        // console.log(encodeURI(registrySearchInput.value));

        if (registrySearchInput.value.trim() !== "") {
            fetchAddressSuggestions(registrySearchInput.value.trim());
        } else {
            addressDropdown.style.display = "none";
            registrySearchButton.setAttribute("href", "javascript:void(0)");
            registrySearchButton.setAttribute("aria-disabled", true);
            registrySearchButton.setAttribute("tabindex", "-1");
            registrySearchButton.removeAttribute("target");
            registrySearchButton.classList.add("disabled");
            document.querySelector('.registry-search .instructions').style.opacity = '0';
        }
    }
    
    const debouncedSearch = _.debounce(function() {
        doSearch()
    }, 500);
    

    // INIT SEARCH: 
    if (document.getElementById('registry-search-input')) {
        registrySearchInput.addEventListener('keyup', function(e) {
            const ignoredKeys = [
                'Shift', 'Control', 'Alt', 'Meta', 'ArrowUp', 'ArrowDown',
                'ArrowLeft', 'ArrowRight', 'Tab', 'CapsLock', 'Escape'
            ];

            if (ignoredKeys.includes(e.key)) {
                return; // Do nothing for ignored keys
            } else {
                debouncedSearch();
            }
        });

        initEventListeners();
    }



});